module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/18ypcaM/tc-custom/9781504073837.jpg?1705205289456",
      "alt": "This image is the cover for the book Polls Apart"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Polls Apart\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Power, ambition, and love collide in this story of a high-profile couple tested by scandal: “Addictive . . . a smart, razor-sharp novel.” —"), _c('i', [_vm._v("Daily Record")])]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Richard Williams has risen in the ranks of British politics and is a stone’s throw from becoming prime minister. But his wife’s latest scandal puts everything he’s worked for in jeopardy—and his adviser is putting pressure on him to cut her loose."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Anna Lloyd, a famous actress, may have embarrassed her husband one too many times, but she sees an opportunity to come clean about her past—including a secret more shocking than any already revealed in the media. The only problem is she might lose her marriage and her beloved sister in the process."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Marie Simpson is a tabloid reporter who’s been tasked with taking Richard and Anna down. Her work will set in motion a personal and political drama that fascinates the public. But will her doubts about destroying lives interfere with the ultimate scoop?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Clare Johnston\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0